import { render, staticRenderFns } from "./ContentContainer.vue?vue&type=template&id=acc12058&scoped=true"
import script from "./ContentContainer.vue?vue&type=script&lang=js"
export * from "./ContentContainer.vue?vue&type=script&lang=js"
import style0 from "./ContentContainer.vue?vue&type=style&index=0&id=acc12058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc12058",
  null
  
)

export default component.exports